import { Params } from '@angular/router';
import { IFilter } from '@epicuro-next/ataraxia/models';
import { FiltersFieldIds } from '@epicuro-next/models/order-book';
import { OrderFilter } from 'graphql-api/baskets-api-interfaces';

export const mapUrlParamsToFilters = (
  params: Params,
  availableFilters: OrderFilter[],
): IFilter[] => {
  return Object.entries(params)
    .filter(([fieldId]) => availableFilters.some((f) => f.fieldId === fieldId))
    .map(([fieldId, paramsValues]): [string, string[]] => {
      const values: string[] = Array.isArray(paramsValues)
        ? paramsValues
        : [paramsValues];

      if (fieldId === FiltersFieldIds.PlacedPeriod) {
        return [fieldId, values];
      }
      const actualFilterValues = availableFilters
        .find((f) => f.fieldId === fieldId)
        ?.values?.map((v) => v.value) as string[];
      const validValues = values.filter((v) => actualFilterValues.includes(v));

      return [fieldId, validValues];
    })
    .reduce(
      (filters: IFilter[], [fieldId, filteredValues]) =>
        filters.concat(filteredValues.map((value) => ({ fieldId, value }))),
      [],
    );
};
